export default {
  hello: "你好",
  introduction: "隆重介紹 {companyName}，這是一家總部位於台灣的獨立威士忌裝瓶公司，其動力來自於對卓越威士忌和海洋保護的熱情。我們的每一瓶威士忌不僅致力於創造捕捉台灣自然美景精髓的威士忌，同時也回饋我們所珍視的海洋。我們利潤的 {profitPercentage} 直接用於海洋保育工作，幫助子孫後代保護和恢復海洋生態系統。",
  announcement: "我們很高興地宣布我們的新版本「海洋花瓣」——一款體現自然與精神之間微妙平衡的限量版表達方式。這款威士忌反映了其創造者返回台灣的旅程，就像新生的海龜找到返回海洋的路一樣。",
  release_availability: "《海洋花瓣》即將上市。",
  responsible_drinking: "負責任地啜飲。保護我們的海洋。",
}